import React from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        // marginTop: theme.spacing(1),
    },
    title: {
        flex: '1 1 100%',
        paddingTop: '20px;'
    },
    submit: {
        // margin: theme.spacing(3, 0, 2),
    }
}));

export default function PresencaAlunoForm({
    presencaAluno,
    handleFaltou,
    handlePresente
}) {
    const classes = useStyles();

    return (
        <Container className={classes.paper} component={Paper} >

            <Typography className={classes.title} variant="h5">
                Nome: {presencaAluno ? presencaAluno.aluno.nome : ''}
            </Typography>
            <Typography className={classes.title} variant="h6">
                Número Chamada: {presencaAluno ? presencaAluno.alunoTurma.numeroChamada : ''}
            </Typography>



            <Button
                type="button"
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={handlePresente}
            >
                Presente
            </Button>
            <Button
                type="button"
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={handleFaltou}
            >
                Falta
            </Button>
        </Container>
    );
}